/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteAgentResponseContent
 */
export interface DeleteAgentResponseContent {
    /**
     * 
     * @type {string}
     * @memberof DeleteAgentResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the DeleteAgentResponseContent interface.
 */
export function instanceOfDeleteAgentResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteAgentResponseContentFromJSON(json: any): DeleteAgentResponseContent {
    return DeleteAgentResponseContentFromJSONTyped(json, false);
}

export function DeleteAgentResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteAgentResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function DeleteAgentResponseContentToJSON(value?: DeleteAgentResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

